@import "../../../global/temporary-mercury-overrides/_button.scss";

:host {
  display: grid;
  block-size: 100%;
  overflow: auto;
  grid-template-rows: 1fr max-content;
}

.main {
  display: grid;
  grid-template-areas:
    "server-url server-url"
    "authentication-type ."
    "user-name user-password";
  grid-auto-rows: max-content;
  grid-template-columns: 1fr 1fr;
}

.section {
  display: contents;
}

.authentication-type {
  grid-area: authentication-type;
}
.server-url {
  grid-area: server-url;
}
.user-name {
  grid-area: user-name;
}
.user-password {
  grid-area: user-password;
}

.tooltip {
  position: absolute;
}
